import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RouteAction } from '@core/action/action';
import { FormService } from '@core/services/form.service';
import { NotificationService } from '@core/services/notification.service';
import { aplicarTrim } from '@shared/util/util';

interface Lista {
  name: string;
  itens: ItemLista[];
}

interface ItemLista {
  id: number;
  descricao: string;
}

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnChanges {

  @ViewChild('formElement') formElement!: ElementRef;

  @Output() dynamicFormSubmit: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() dynamicFormReset: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormCancell: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormAdicionarItemCena: EventEmitter<number> = new EventEmitter<number>();
  @Output() dynamicFormAdicionarTodosCena: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormReaproveitarCena: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormCadastrarNovoCena: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  dynamicForm!: FormGroup;
  @Input() formName: any;
  @Input() fields: any[] = [];
  @Input() lists: any[] = [];
  @Input() rowClass!: string;
  @Input() border: boolean = false;
  @Input() formType: FormTypeEnum = FormTypeEnum.Filter;
  @Input() acao!: RouteAction;
  @Input() isCena: boolean = false;

  optionValueFn: string = 'id';
  optionLabelFn: string = 'descricao';

  sortedFields: any[] = [];

  typeField = TypeFieldEnum;
  typeFieldEnum = TypeFieldEnum;
  formTypeEnum = FormTypeEnum;
  routeActionEnum = RouteAction;

  constructor(
    private formBuilder: FormBuilder,
    private formService: FormService,
    private notificationService: NotificationService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.sortedFields = this.sortFields(changes['fields']?.currentValue);
    this.dynamicForm = this.createDynamicForm(this.sortedFields);

    if (this.isCena) {
      this.dynamicForm.controls['select'].valueChanges.subscribe(val => {
        if (val) {
          this.dynamicFormAdicionarItemCena.emit(val)
        }
      });
    }
  }

  sortFields(fields: any[]): any[] {
    return fields.slice().sort((a, b) => a.order - b.order);
  }

  createDynamicForm(fields: any[]) {
    const formGroup = this.formBuilder.group({});

    fields.forEach(field => {
      const validators = field.required ? [Validators.required] : [];
      formGroup.addControl(field.name, this.formBuilder.control(null, validators));
    });

    return formGroup;
  }

  onSubmit() {
    const messages = this.formService.getValidationsMessages(this.dynamicForm, this.formElement);
    // this.formService.validateAllFormFields(this.dynamicForm);

    if (messages.length) {
      // this.notificationService.warn('Os seguintes campos abaixo devem ser preenchidos corretamente:', this.formService.createValidationList(messages));
      return;
    }

    if (this.dynamicForm.valid) {
      aplicarTrim(this.dynamicForm);
      this.dynamicFormSubmit.emit(this.dynamicForm);
    } else {
      this.notificationService.error('Atenção', 'Existem campos obrigatórios a serem preenchidos.');
    }
  }

  reset() {
    this.dynamicForm.reset();
    this.dynamicFormReset.emit(true);
  }

  back() {
    this.dynamicFormCancell.emit(true);
  }

  getFieldList(fieldName: string) {
    const field = this.fields.find(f => f.name === fieldName);

    if (field.type == TypeFieldEnum.Select) {
      if (!field || !this.lists) {
        return [];
      }
      const list = this.lists.find(itens => itens.name == field.list);
      return list ? list.itens : [];
    }
    return []
  }

  getOptionValue(item: any, optionValueFn?: string): any {
    optionValueFn = optionValueFn ?? 'id';
    return optionValueFn == 'item' ? item : item[optionValueFn];
  }

  getOptionLabel(item: any, optionLabelFn?: string): any {
    optionLabelFn = optionLabelFn ?? 'descricao';
    return optionLabelFn == 'item' ? item : item[optionLabelFn];
  }

  selecionarTodos() {
    this.dynamicFormAdicionarTodosCena.emit(true);
  }

  reaproveitar() {
    this.dynamicFormReaproveitarCena.emit(true);
  }

  cadastrarNovo() {
    this.dynamicFormCadastrarNovoCena.emit(true);
  }
}

export enum TypeFieldEnum {
  Input = 'input',
  Select = 'select',
  TextArea = 'textArea',
  DatePicker = 'datePicker',
  InputGroup = 'InputGroup'
}

export enum FormTypeEnum {
  Filter = 'filter',
  Submit = 'submit'
}
